import React, { useRef, useState } from "react";
import { cn } from "../../lib/utils";
import { Button } from "./button";
import { X, Upload } from "lucide-react";

const FileInput = React.forwardRef(({
  className,
  value,
  onChange,
  onRemove,
  accept,
  multiple = false,
  buttonText = "Selecionar arquivo",
  ...props
}, ref) => {
  const inputRef = useRef(null);
  const [fileNames, setFileNames] = useState([]);
  
  const handleClick = () => {
    inputRef.current?.click();
  };
  
  const handleChange = (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;
    
    setFileNames(prev => [...prev, ...files.map(f => f.name)]);
    
    if (onChange) {
      onChange(multiple ? files : files[0]);
    }
  };
  
  const handleRemove = (index) => {
    setFileNames(prev => prev.filter((_, i) => i !== index));
    
    if (onRemove) {
      onRemove(index);
    }
  };
  
  return (
    <div className={cn("space-y-2", className)} {...props}>
      <div className="flex items-center gap-2">
        <Button
          type="button"
          variant="outline"
          onClick={handleClick}
          className="flex items-center gap-2"
        >
          <Upload className="h-4 w-4" />
          {buttonText}
        </Button>
        <input
          type="file"
          ref={inputRef}
          className="hidden"
          accept={accept}
          multiple={multiple}
          onChange={handleChange}
        />
      </div>
      
      {fileNames.length > 0 && (
        <ul className="space-y-1 mt-2">
          {fileNames.map((name, index) => (
            <li 
              key={index} 
              className="flex items-center justify-between rounded-md border px-3 py-2 text-sm"
            >
              <span className="truncate max-w-[250px]">{name}</span>
              <Button
                type="button"
                variant="ghost"
                size="icon"
                className="h-6 w-6"
                onClick={() => handleRemove(index)}
              >
                <X className="h-4 w-4" />
                <span className="sr-only">Remover arquivo</span>
              </Button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
});

FileInput.displayName = "FileInput";

export { FileInput };
